(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_lucide-carte-monde"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideCmInit) return;
    window.lucideCmInit = true;

    function initTous() {
      document.querySelectorAll('.lucide-cm').forEach(function (racine) {
        if (racine.dataset.lucideCmPret) return;
        racine.dataset.lucideCmPret = '1';
        var conteneurPoints = racine.querySelector('[data-lucide-cm-points]');
        if (!conteneurPoints) return;
        conteneurPoints.textContent = '';

        /* Libellés Origine / Fournisseur : réglages du parent, injectés dans les
           fiches des enfants (un enfant ne connaît pas les réglages du parent). */
        racine.querySelectorAll('[data-lucide-cm-label]').forEach(function (l) {
          l.textContent = l.dataset.lucideCmLabel === 'origine'
            ? (racine.dataset.labelOrigine || '')
            : (racine.dataset.labelFournisseur || '');
        });

        /* Mode BULLE : les fiches déménagent dans la zone carte (ancre stable),
           chaque point devient cliquable et ouvre SA fiche, une croix la ferme. */
        var enBulle = racine.classList.contains('lucide-cm--fiches-bulle');
        var fichesConteneur = racine.querySelector('[data-lucide-cm-fiches]');
        var zoneCarte = racine.querySelector('.lucide-cm__carte');
        if (enBulle && fichesConteneur && zoneCarte) {
          zoneCarte.appendChild(fichesConteneur);
          conteneurPoints.removeAttribute('aria-hidden');
        }

        var paires = [];
        function activer(i) {
          paires.forEach(function (p, j) {
            p[0].classList.toggle('est-actif', i === j);
            p[0].setAttribute('aria-pressed', i === j ? 'true' : 'false');
            p[1].forEach(function (pt) { pt.classList.toggle('est-actif', i === j); });
          });
        }
        function ouvrirBulle(i) {
          if (!enBulle) return;
          paires.forEach(function (p, j) {
            p[0].classList.toggle('est-ouverte', i === j);
          });
        }
        racine.querySelectorAll('[data-lucide-cm-fiche]').forEach(function (fiche, i) {
          /* Un ingrédient peut déclarer PLUSIEURS positions (ex. produit en
             Europe ET en Chine) : un point par span, tous liés à la même fiche. */
          var spans = fiche.querySelectorAll('[data-lucide-cm-point]');
          if (!spans.length) return;
          /* Un point supplémentaire sans couleur propre hérite de celle
             du point principal de sa fiche. */
          var couleurFiche = spans[0].dataset.couleur || '';
          var points = [];
          spans.forEach(function (d) {
            var point = document.createElement('span');
            point.className = 'lucide-cm__point';
            point.style.left = d.dataset.x + '%';
            point.style.top = d.dataset.y + '%';
            var couleur = d.dataset.couleur || couleurFiche;
            if (couleur) point.style.setProperty('--lcm-point-perso', couleur);
            if (racine.dataset.formePoints === 'epingle') {
              point.classList.add('lucide-cm__point--epingle');
              /* Le tracé EXACT de l'épingle fournie par Omar (hotspot-icon.svg,
                 2026-08-20) — fill-rule evenodd garantit le trou central. */
              point.innerHTML = '<svg viewBox="0 0 19.753 27.589" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M26.215,9.893a9.876,9.876,0,1,0-19.753,0c0,2.157.973,3.983,1.861,5.779,1.546,3.127,4.395,8.051,5.895,10.717a2.688,2.688,0,0,0,4.476,0c1.468-2.663,3.975-6.941,5.685-10.752C25.193,13.825,26.215,12.037,26.215,9.893ZM16.338,6.656A3.237,3.237,0,1,1,13.1,9.893,3.238,3.238,0,0,1,16.338,6.656Z" transform="translate(-6.462)"/></svg>';
            }
            conteneurPoints.appendChild(point);
            points.push(point);
            if (enBulle) {
              var nomFiche = fiche.querySelector('.lucide-cm__fiche-nom');
              point.classList.add('lucide-cm__point--cliquable');
              point.setAttribute('role', 'button');
              point.setAttribute('tabindex', '0');
              point.setAttribute('aria-label', nomFiche ? nomFiche.textContent : 'Ingrédient');
              var montrer = function () { activer(i); ouvrirBulle(i); };
              point.addEventListener('click', montrer);
              point.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); montrer(); }
              });
            }
          });
          fiche.addEventListener('click', function () { activer(i); });
          paires.push([fiche, points]);
          if (enBulle) {
            var croix = document.createElement('span');
            croix.className = 'lucide-cm__bulle-croix';
            croix.setAttribute('role', 'button');
            croix.setAttribute('tabindex', '0');
            croix.setAttribute('aria-label', 'Fermer');
            croix.textContent = '✕';
            fiche.appendChild(croix);
            var fermer = function (e) { e.stopPropagation(); fiche.classList.remove('est-ouverte'); };
            croix.addEventListener('click', fermer);
            croix.addEventListener('keydown', function (e) { if (e.key === 'Enter') fermer(e); });
          }
        });
        if (paires.length) activer(0);

        /* ===== Glissement de la carte par le client ===== */
        var cadre = racine.querySelector('[data-lucide-cm-cadre]');
        var nav = racine.querySelector('[data-lucide-cm-nav]');
        var prec = racine.querySelector('[data-lucide-cm-prec]');
        var suiv = racine.querySelector('[data-lucide-cm-suiv]');
        var curseur = racine.querySelector('[data-lucide-cm-curseur]');
        var douceur = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        var demarre = false;

        function majNav() {
          if (!cadre) return;
          var max = cadre.scrollWidth - cadre.clientWidth;
          if (nav) nav.hidden = max <= 2;
          if (prec) prec.disabled = cadre.scrollLeft <= 2;
          if (suiv) suiv.disabled = cadre.scrollLeft >= max - 2;
          if (curseur && cadre.scrollWidth > 0) {
            var part = cadre.clientWidth / cadre.scrollWidth;
            curseur.style.width = Math.max(part * 100, 8) + '%';
            var avance = max > 0 ? cadre.scrollLeft / max : 0;
            curseur.style.left = avance * (100 - Math.max(part * 100, 8)) + '%';
          }
        }
        /* Position de départ (centre horizontal de l'éditeur) — seulement quand
           la carte est VISIBLE : cachée, sa géométrie vaut 0 (leçon volet). */
        function demarrer() {
          if (!cadre || demarre || cadre.clientWidth === 0) return;
          var max = cadre.scrollWidth - cadre.clientWidth;
          if (max > 0) {
            var cx = parseFloat(racine.dataset.centreX || '50') / 100;
            cadre.scrollLeft = cx * cadre.scrollWidth - cadre.clientWidth / 2;
          }
          demarre = true;
          majNav();
        }
        if (cadre) {
          /* La bascule qui nous affiche : celle du carrousel (.lucide-ci__vue)
             ou la coche de la section Carte origines (.lcor__coche). */
          var hote = racine.closest('.lucide-ci') || racine.closest('.lcor');
          var bascule = hote && (hote.querySelector('.lucide-ci__vue') || hote.querySelector('.lcor__coche'));
          if (bascule) bascule.addEventListener('change', function () { setTimeout(demarrer, 50); });
          /* Dans un volet <details> (bloc Volet déroulant) : la carte naît
             cachée (géométrie 0) — chaque ouverture d'un volet ancêtre
             redonne une chance à la position de départ. */
          var det = racine.closest('details');
          while (det) {
            det.addEventListener('toggle', function () { setTimeout(demarrer, 50); });
            det = det.parentElement ? det.parentElement.closest('details') : null;
          }
          demarrer();
          cadre.addEventListener('scroll', function () { setTimeout(majNav, 60); });
          window.addEventListener('resize', majNav);
          if (prec) prec.addEventListener('click', function () { cadre.scrollBy({ left: -cadre.clientWidth * 0.4, behavior: douceur }); });
          if (suiv) suiv.addEventListener('click', function () { cadre.scrollBy({ left: cadre.clientWidth * 0.4, behavior: douceur }); });
          /* Glisser à la souris (le doigt = défilement natif du cadre) */
          if (racine.dataset.glisser === '1') {
            var saisie = null;
            cadre.addEventListener('pointerdown', function (e) {
              if (e.pointerType !== 'mouse') return;
              saisie = { x: e.clientX, depart: cadre.scrollLeft };
              cadre.classList.add('est-saisi');
            });
            cadre.addEventListener('pointermove', function (e) {
              if (!saisie) return;
              cadre.scrollLeft = saisie.depart - (e.clientX - saisie.x);
            });
            ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
              cadre.addEventListener(evt, function () { saisie = null; cadre.classList.remove('est-saisi'); });
            });
          }
        }

        /* Dans l'éditeur : sélectionner un bloc Point active sa fiche */
        racine.addEventListener('shopify:block:select', function (e) {
          var fiche = e.target.matches && e.target.matches('[data-lucide-cm-fiche]')
            ? e.target
            : (e.target.querySelector && e.target.querySelector('[data-lucide-cm-fiche]'))
              || (e.target.closest && e.target.closest('[data-lucide-cm-fiche]'));
          if (!fiche) return;
          var i = paires.findIndex(function (p) { return p[0] === fiche; });
          if (i > -1) { activer(i); ouvrirBulle(i); }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTous);
    } else {
      initTous();
    }
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector && e.target.querySelector('.lucide-cm')) {
        e.target.querySelectorAll('.lucide-cm').forEach(function (r) { delete r.dataset.lucideCmPret; });
        initTous();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_lucide-faq-onglet"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideFaqOngletsInit) return;
    window.lucideFaqOngletsInit = true;

    /* Pour chaque section FAQ-image : ramasser les onglets, fabriquer la barre
       de pastilles, activer le premier. Sans onglet, la barre reste cachée et
       la section garde sa liste plate d'origine. */
    function initTous() {
      document.querySelectorAll('.lucide-fi').forEach(function (racine) {
        var barre = racine.querySelector('[data-lucide-fi-onglets]');
        if (!barre) return;
        var onglets = Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-fo]'));
        if (!onglets.length) {
          barre.hidden = true;
          racine.removeAttribute('data-lucide-fi-pret');
          return;
        }
        barre.innerHTML = '';
        var boutons = onglets.map(function (onglet, i) {
          var nom = onglet.querySelector('[data-lucide-fo-nom]');
          var bouton = document.createElement('button');
          bouton.type = 'button';
          bouton.className = 'lucide-fi__onglet';
          bouton.textContent = nom ? nom.textContent : 'Onglet';
          bouton.setAttribute('aria-selected', 'false');
          bouton.addEventListener('click', function () { activer(i); });
          barre.appendChild(bouton);
          return bouton;
        });
        function activer(i) {
          onglets.forEach(function (onglet, j) {
            onglet.classList.toggle('est-actif', j === i);
            boutons[j].classList.toggle('est-actif', j === i);
            boutons[j].setAttribute('aria-selected', j === i ? 'true' : 'false');
          });
          racine.lucideFoIndexActif = i;
          /* La barre suit : centrer la pastille active quand la barre défile (mobile) */
          if (barre.scrollWidth > barre.clientWidth) {
            barre.scrollTo({
              left: boutons[i].offsetLeft - (barre.clientWidth - boutons[i].offsetWidth) / 2,
              behavior: 'smooth'
            });
          }
        }
        /* Posée sur la racine pour que les événements ci-dessous retrouvent
           l'activation de LEUR section (plusieurs FAQ possibles sur une page). */
        racine.lucideFoActiver = function (element) {
          var conteneur = element.closest && element.closest('[data-lucide-fo]');
          if (!conteneur) return;
          var i = onglets.indexOf(conteneur);
          if (i >= 0) activer(i);
        };
        racine.lucideFoNb = onglets.length;
        racine.lucideFoActiverIndex = activer;
        /* Balayage tactile : glisser les questions vers la gauche/droite change
           d'onglet. Les propriétés lucideFo* de la racine sont relues à chaque
           geste : une ré-initialisation (éditeur) ne laisse pas de fermeture
           périmée. Écouteurs passifs : le défilement vertical n'est pas gêné. */
        var liste = racine.querySelector('.lucide-fi__liste');
        if (liste && racine.hasAttribute('data-lucide-fi-glisse') && !liste.lucideFoGlisse) {
          liste.lucideFoGlisse = true;
          var departX = null;
          var departY = null;
          liste.addEventListener('touchstart', function (e) {
            departX = e.touches[0].clientX;
            departY = e.touches[0].clientY;
          }, { passive: true });
          liste.addEventListener('touchend', function (e) {
            if (departX === null) return;
            var dx = e.changedTouches[0].clientX - departX;
            var dy = e.changedTouches[0].clientY - departY;
            departX = departY = null;
            /* Geste franc et surtout horizontal, sinon on laisse défiler */
            if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
            var vise = racine.lucideFoIndexActif + (dx < 0 ? 1 : -1);
            if (vise >= 0 && vise < racine.lucideFoNb) racine.lucideFoActiverIndex(vise);
          }, { passive: true });
        }
        activer(0);
        barre.hidden = false;
        racine.setAttribute('data-lucide-fi-pret', '');
      });
    }

    /* Une ancre vise une question cachée dans un onglet → révéler l'onglet
       AVANT le défilement (événement émis par les JS d'ancres LUCIDE). */
    document.addEventListener('lucide:reveler', function (e) {
      var cible = e.detail;
      if (!cible || !cible.closest) return;
      var racine = cible.closest('.lucide-fi');
      if (racine && racine.lucideFoActiver) racine.lucideFoActiver(cible);
    });

    /* Éditeur : cliquer un onglet ou une question dans le panneau l'affiche. */
    document.addEventListener('shopify:block:select', function (e) {
      var racine = e.target.closest && e.target.closest('.lucide-fi');
      if (racine && racine.lucideFoActiver) racine.lucideFoActiver(e.target);
    });
    document.addEventListener('shopify:section:load', initTous);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTous);
    } else {
      initTous();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_lucide-onglet-gamme"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideGammeOngletsInit) return;
    window.lucideGammeOngletsInit = true;

    function initTous() {
      document.querySelectorAll('.lgv').forEach(function (racine) {
        var barre = racine.querySelector('[data-lucide-lgv-onglets]');
        if (!barre) return;
        var onglets = Array.prototype.slice.call(racine.querySelectorAll('[data-lucide-go]'));
        if (!onglets.length) {
          barre.hidden = true;
          racine.removeAttribute('data-lucide-lgv-pret');
          return;
        }
        barre.innerHTML = '';
        var boutons = onglets.map(function (onglet, i) {
          var nom = onglet.querySelector('[data-lucide-go-nom]');
          var bouton = document.createElement('button');
          bouton.type = 'button';
          bouton.className = 'lgv__onglet';
          bouton.textContent = nom ? nom.textContent : 'Gamme';
          bouton.setAttribute('aria-selected', 'false');
          bouton.addEventListener('click', function () { activer(i); });
          barre.appendChild(bouton);
          return bouton;
        });
        function activer(i) {
          onglets.forEach(function (onglet, j) {
            onglet.classList.toggle('est-actif', j === i);
            boutons[j].classList.toggle('est-actif', j === i);
            boutons[j].setAttribute('aria-selected', j === i ? 'true' : 'false');
          });
          racine.lucideGoIndexActif = i;
          if (barre.scrollWidth > barre.clientWidth) {
            barre.scrollTo({
              left: boutons[i].offsetLeft - (barre.clientWidth - boutons[i].offsetWidth) / 2,
              behavior: 'smooth'
            });
          }
        }
        racine.lucideGoActiver = function (element) {
          var conteneur = element.closest && element.closest('[data-lucide-go]');
          if (!conteneur) return;
          var i = onglets.indexOf(conteneur);
          if (i >= 0) activer(i);
        };
        racine.lucideGoNb = onglets.length;
        racine.lucideGoActiverIndex = activer;
        var grille = racine.querySelector('.lgv__grille');
        if (grille && racine.hasAttribute('data-lucide-lgv-glisse') && !grille.lucideGoGlisse) {
          grille.lucideGoGlisse = true;
          var departX = null;
          var departY = null;
          grille.addEventListener('touchstart', function (e) {
            departX = e.touches[0].clientX;
            departY = e.touches[0].clientY;
          }, { passive: true });
          grille.addEventListener('touchend', function (e) {
            if (departX === null) return;
            var dx = e.changedTouches[0].clientX - departX;
            var dy = e.changedTouches[0].clientY - departY;
            departX = departY = null;
            if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
            var vise = racine.lucideGoIndexActif + (dx < 0 ? 1 : -1);
            if (vise >= 0 && vise < racine.lucideGoNb) racine.lucideGoActiverIndex(vise);
          }, { passive: true });
        }
        activer(0);
        barre.hidden = false;
        racine.setAttribute('data-lucide-lgv-pret', '');
      });
    }

    document.addEventListener('lucide:reveler', function (e) {
      var cible = e.detail;
      if (!cible || !cible.closest) return;
      var racine = cible.closest('.lgv');
      if (racine && racine.lucideGoActiver) racine.lucideGoActiver(cible);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var racine = e.target.closest && e.target.closest('.lgv');
      if (racine && racine.lucideGoActiver) racine.lucideGoActiver(e.target);
    });
    document.addEventListener('shopify:section:load', initTous);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTous);
    } else {
      initTous();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-avis-verifie"] && !Shopify.designMode) return;
  try {
    /* Deux déplacements possibles, selon les cases cochées :
     - « Ordinateur : sous les photos » : le bloc posé dans « Détails du produit » part dans la
       colonne des photos (sous la galerie) à partir de 750 px, et revient à sa place en dessous.
     - « Téléphone : après les détails » : le bloc posé sous la galerie part en fin de
       « Détails du produit » sous 750 px, et revient à sa place au-dessus.
     La place d'origine est mémorisée au premier déplacement. */
  (function () {
    if (window.lucideAvisVerifie) return;
    window.lucideAvisVerifie = true;
    var origines = new Map();
    var mq = window.matchMedia('(max-width: 749px)');
    function remettre(noeud) {
      var o = origines.get(noeud);
      if (!o || noeud.parentElement === o.parent) return;
      if (o.suivant && o.suivant.parentElement === o.parent) o.parent.insertBefore(noeud, o.suivant);
      else o.parent.appendChild(noeud);
    }
    function deplacer(noeud, cible) {
      if (!cible || noeud.parentElement === cible) return;
      if (!origines.has(noeud)) origines.set(noeud, { parent: noeud.parentElement, suivant: noeud.nextSibling });
      cible.appendChild(noeud);
    }
    function placer() {
      var blocs = document.querySelectorAll('[data-lav-tel-fin], [data-lav-ordi-photos]');
      for (var i = 0; i < blocs.length; i++) {
        var el = blocs[i];
        var noeud = el.closest('.shopify-block') || el;
        var grille = noeud.closest('.product-information__grid');
        if (!grille) continue;
        if (mq.matches) {
          if (el.hasAttribute('data-lav-tel-fin')) deplacer(noeud, grille.querySelector('.product-details .group-block-content') || grille.querySelector('.product-details'));
          else remettre(noeud);
        } else {
          if (el.hasAttribute('data-lav-ordi-photos')) deplacer(noeud, grille.querySelector('.lucide-sous-galerie') || grille.querySelector('.product-information__media'));
          else remettre(noeud);
        }
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placer);
    else placer();
    mq.addEventListener('change', placer);
    document.addEventListener('shopify:section:load', function () { origines = new Map(); placer(); });
    document.addEventListener('shopify:block:select', placer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-badge-labo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucide-pdf-labo')) {
    const PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
    let chargement = null;
    const chargerPdfjs = () =>
      (chargement ||= new Promise((ok, ko) => {
        if (window.pdfjsLib) return ok(window.pdfjsLib);
        const s = document.createElement('script');
        s.src = PDFJS + 'pdf.min.js';
        s.onload = () => {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
          ok(window.pdfjsLib);
        };
        s.onerror = () => {
          chargement = null;
          ko(new Error('pdf.js'));
        };
        document.head.append(s);
      }));
    const ecart = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);

    class LucidePdfLabo extends HTMLElement {
      connectedCallback() {
        this.fenetre = this.querySelector('dialog');
        this.zone = this.querySelector('[data-lbpdf-zone]');
        this.pages = this.querySelector('[data-lbpdf-pages]');
        this.z = 1;
        this.querySelector('[data-lbpdf-ouvrir]').addEventListener('click', (e) => {
          e.preventDefault();
          this.ouvrir();
        });
        this.querySelector('[data-lbpdf-fermer]').addEventListener('click', () => this.fenetre.close());
        this.querySelectorAll('[data-lbpdf-zoom]').forEach((b) =>
          b.addEventListener('click', () =>
            this.zoomer(this.z * (b.dataset.lbpdfZoom > 0 ? 1.5 : 1 / 1.5), this.zone.clientWidth / 2, this.zone.clientHeight / 2)
          )
        );
        this.fenetre.addEventListener('close', () => {
          this.verrou(false);
          this.zoomer(1, 0, 0);
        });
        // Échap ne ferme que le PDF, pas une fenêtre ouverte derrière (carte des ingrédients)
        this.fenetre.addEventListener('keydown', (e) => e.key === 'Escape' && e.stopPropagation());
        // Safari iOS : sans ça, le pincement zoome toute la page au lieu du PDF
        this.fenetre.addEventListener('gesturestart', (e) => e.preventDefault());
        const zo = this.zone;
        zo.addEventListener('touchstart', (e) => {
          if (e.touches.length === 2) this.pince = { d: ecart(e.touches), z: this.z };
          if (e.touches.length === 1) this.depart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }, { passive: true });
        zo.addEventListener('touchmove', (e) => {
          if (e.touches.length !== 2 || !this.pince) return;
          e.preventDefault();
          const r = zo.getBoundingClientRect();
          const [a, b] = e.touches;
          this.zoomer(this.pince.z * ecart(e.touches) / this.pince.d, (a.clientX + b.clientX) / 2 - r.left, (a.clientY + b.clientY) / 2 - r.top);
        }, { passive: false });
        zo.addEventListener('touchend', (e) => {
          if (e.touches.length < 2) this.pince = null;
          // double tape : zoom ×2,5 à l'endroit touché, ou retour à la page entière
          const t = e.changedTouches[0];
          if (e.touches.length || !this.depart || Math.hypot(t.clientX - this.depart.x, t.clientY - this.depart.y) > 10) return;
          const maintenant = Date.now();
          if (maintenant - (this.tape || 0) < 300) {
            const r = zo.getBoundingClientRect();
            this.zoomer(this.z > 1.2 ? 1 : 2.5, t.clientX - r.left, t.clientY - r.top);
            this.tape = 0;
          } else this.tape = maintenant;
        });
        // pincement du pavé tactile (ordinateur)
        zo.addEventListener('wheel', (e) => {
          if (!e.ctrlKey) return;
          e.preventDefault();
          const r = zo.getBoundingClientRect();
          this.zoomer(this.z * Math.exp(-e.deltaY / 100), e.clientX - r.left, e.clientY - r.top);
        }, { passive: false });
      }

      verrou(actif) {
        const html = document.documentElement;
        import('@theme/utilities')
          .then((u) => (actif ? u.lockScroll(this.fenetre) : u.unlockScroll(this.fenetre)))
          .catch(() => html.toggleAttribute('scroll-lock', actif));
      }

      ouvrir() {
        this.fenetre.showModal();
        this.verrou(true);
        this.rendre();
      }

      zoomer(z, mx, my) {
        z = Math.min(4, Math.max(1, z));
        const zo = this.zone;
        const k = z / this.z;
        const x = zo.scrollLeft + mx;
        const y = zo.scrollTop + my;
        this.z = z;
        this.pages.style.setProperty('--lbpdf-z', z);
        zo.scrollLeft = x * k - mx;
        zo.scrollTop = y * k - my;
      }

      async rendre() {
        if (this.rendu) return;
        this.rendu = true;
        try {
          const lib = await chargerPdfjs();
          const doc = await lib.getDocument(this.dataset.pdf).promise;
          // Une page n'est dessinée que près de l'écran, et effacée quand elle s'en éloigne :
          // toutes les pages en haute définition saturaient la mémoire du téléphone (32 pages de la B6 ≈ 1 Go,
          // l'iPhone rechargeait la page). Définition ≈ 3 px par point à l'écran, plafonnée à 1600 px.
          const largeur = Math.min(this.pages.clientWidth * Math.min(window.devicePixelRatio || 1, 2) * 1.5, 1600);
          const dessiner = async (c) => {
            if (c.dessine) return;
            c.dessine = true;
            const jeton = (c.jeton = (c.jeton || 0) + 1);
            const page = await doc.getPage(+c.dataset.n);
            const vue = page.getViewport({ scale: largeur / page.getViewport({ scale: 1 }).width });
            if (c.jeton !== jeton) return;
            c.width = vue.width;
            c.height = vue.height;
            const tache = (c.tache = page.render({ canvasContext: c.getContext('2d'), viewport: vue }));
            await tache.promise.catch(() => {});
            if (c.tache === tache) c.tache = null;
          };
          const effacer = (c) => {
            if (!c.dessine) return;
            c.dessine = false;
            c.jeton = (c.jeton || 0) + 1;
            if (c.tache) c.tache.cancel();
            c.width = 0;
            c.height = 0;
          };
          const vigie = new IntersectionObserver(
            (entrees) => entrees.forEach((e) => (e.isIntersecting ? dessiner(e.target) : effacer(e.target))),
            { root: this.zone, rootMargin: '100% 0px' }
          );
          const toiles = [];
          for (let n = 1; n <= doc.numPages; n++) {
            const v = (await doc.getPage(n)).getViewport({ scale: 1 });
            const c = document.createElement('canvas');
            c.className = 'lbpdf__page';
            c.dataset.n = n;
            c.width = 0;
            c.height = 0;
            c.style.aspectRatio = v.width / v.height;
            toiles.push(c);
          }
          this.pages.replaceChildren(...toiles);
          toiles.forEach((c) => vigie.observe(c));
        } catch (e) {
          // PDF.js indisponible : on ouvre le PDF tel quel
          this.rendu = false;
          this.fenetre.close();
          window.location.href = this.dataset.pdf;
        }
      }
    }
    customElements.define('lucide-pdf-labo', LucidePdfLabo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-bouton-panier"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideBpInit) return;
    window.lucideBpInit = true;

    /* Synchronisation : l'offre cochée porte ses prix en data-attributs ; on les
       recopie dans chaque bouton qui suit. Deux sources, LucidCure d'abord :
       cure cochée × mode coché (offre découverte / achat unique), sinon le bundle.
       Offre sans prix renseignés = le bouton garde son affichage actuel. */
    function offreActive() {
      var cures = document.querySelector('.lucide-cures');
      if (cures) {
        var cure = cures.querySelector('.lucide-cure > input:checked');
        var mode = cures.querySelector('.lucide-cures__mode:checked');
        if (cure && mode) {
          /* les panneaux suivent leur carte par adjacence : carte → offre → unique */
          var carte = cure.closest('.lucide-cure');
          var offre = carte ? carte.nextElementSibling : null;
          var unique = offre ? offre.nextElementSibling : null;
          var panneau = mode.value === 'unique' ? unique : offre;
          if (panneau && panneau.hasAttribute('data-lucide-of-prix')) return panneau;
        }
      }
      var coche = document.querySelector('.lucide-offre input:checked');
      return coche ? coche.closest('.lucide-offre') : null;
    }

    function majBoutons() {
      var offre = offreActive();
      if (!offre) return;
      var barre = (offre.getAttribute('data-lucide-of-barre') || '').trim();
      var prix = (offre.getAttribute('data-lucide-of-prix') || '').trim();
      if (!barre && !prix) return;
      Array.prototype.forEach.call(document.querySelectorAll('.lucide-bp--suit'), function (bp) {
        var eBarre = bp.querySelector('.lucide-bp__barre');
        var eTiret = bp.querySelector('.lucide-bp__tiret');
        var ePrix = bp.querySelector('.lucide-bp__prix');
        if (ePrix && prix) {
          ePrix.textContent = prix;
          ePrix.hidden = false;
        }
        if (eBarre) {
          if (barre) {
            eBarre.textContent = barre;
            eBarre.hidden = false;
          } else {
            eBarre.hidden = true;
          }
          if (eTiret) eTiret.hidden = eBarre.hidden;
        }
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.lucide-offre input, .lucide-cures input')) majBoutons();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', majBoutons);
    } else {
      majBoutons();
    }
    document.addEventListener('shopify:section:load', majBoutons);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-bouton"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideBoutonAncre) return;
    window.lucideBoutonAncre = true;
    document.addEventListener('click', function (e) {
      var lien = e.target.closest('[data-lucide-bouton-ancre]');
      if (!lien) return;
      var id = (lien.getAttribute('href') || '').slice(1);
      var cible = id && document.getElementById(id);
      if (!cible) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('lucide:reveler', { detail: cible }));
      var pliage = cible.closest('details');
      if (pliage) pliage.open = true;
      var defile = cible.closest('.lucide-fi') || cible;
      defile.style.scrollMarginTop = '90px';
      var douceur = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      defile.scrollIntoView({ behavior: douceur, block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-bulles-story"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideStoriesInit) return;
    window.lucideStoriesInit = true;

    var etat = null;

    function lesMedias(bulle) {
      return Array.prototype.slice.call(bulle.querySelectorAll('.lucide-bulle__medias .lucide-media'));
    }

    /* ----- Aperçu animé dans les bulles -----
       La 1re vidéo de la story est clonée DANS la bulle : muette, en boucle,
       lecture uniquement quand la bulle est visible à l'écran. Le son n'existe
       que dans le lecteur plein écran. Sans coche (ou reduced-motion) : image
       fixe — la couverture, sinon l'image de la vidéo posée sur la vignette. */
    var observateurApercus = null;

    function observerApercu(apercu) {
      if (!('IntersectionObserver' in window)) { apercu.play().catch(function () {}); return; }
      if (!observateurApercus) {
        observateurApercus = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (entree) {
            if (entree.isIntersecting) {
              entree.target.setAttribute('data-visible', '');
              if (!etat) entree.target.play().catch(function () {});
            } else {
              entree.target.removeAttribute('data-visible');
              entree.target.pause();
            }
          });
        }, { threshold: 0.2 });
      }
      observateurApercus.observe(apercu);
    }

    function pauserApercus() {
      Array.prototype.slice.call(document.querySelectorAll('.lucide-bulle__apercu')).forEach(function (v) { v.pause(); });
    }

    function reprendreApercus() {
      Array.prototype.slice.call(document.querySelectorAll('.lucide-bulle__apercu[data-visible]')).forEach(function (v) { v.play().catch(function () {}); });
    }

    function initApercus() {
      var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      Array.prototype.slice.call(document.querySelectorAll('[data-lucide-bulle]')).forEach(function (bulle) {
        var source = bulle.querySelector('.lucide-bulle__medias video');
        if (!source) return;
        /* Vignette vide + story vidéo : l'image de la vidéo sert de couverture */
        var vide = bulle.querySelector('.lucide-bulle__image--vide');
        var poster = source.getAttribute('poster');
        if (vide && poster) {
          vide.style.backgroundImage = 'url("' + poster + '")';
          vide.style.backgroundSize = 'cover';
          vide.style.backgroundPosition = 'center';
        }
        if (!bulle.hasAttribute('data-lucide-apercu') || reduit) return;
        if (bulle.querySelector('.lucide-bulle__apercu')) return; /* déjà installé */
        var apercu = source.cloneNode(true);
        apercu.className = 'lucide-bulle__apercu';
        apercu.removeAttribute('controls');
        apercu.setAttribute('muted', '');
        apercu.setAttribute('playsinline', '');
        apercu.setAttribute('loop', '');
        apercu.setAttribute('aria-hidden', 'true');
        apercu.muted = true;
        apercu.defaultMuted = true;
        apercu.preload = 'metadata';
        bulle.querySelector('.lucide-bulle__anneau').appendChild(apercu);
        observerApercu(apercu);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initApercus);
    } else {
      initApercus();
    }
    document.addEventListener('shopify:section:load', initApercus);

    function arreter() {
      if (!etat) return;
      clearTimeout(etat.timer);
      var scene = etat.lecteur.querySelector('.lucide-story-lecteur__scene');
      var video = scene.querySelector('video');
      if (video) video.pause();
    }

    function fermer() {
      if (!etat) return;
      arreter();
      document.documentElement.removeAttribute('scroll-lock');
      try { etat.lecteur.close(); } catch (e) {}
      etat.lecteur.querySelector('.lucide-story-lecteur__scene').innerHTML = '';
      etat = null;
      reprendreApercus();
    }

    function montrer() {
      arreter();
      var bulle = etat.bulles[etat.iB];
      var liste = lesMedias(bulle);
      if (!liste.length) { suivantBulle(); return; }
      if (etat.iM >= liste.length) etat.iM = liste.length - 1;
      var scene = etat.lecteur.querySelector('.lucide-story-lecteur__scene');
      scene.innerHTML = '';
      var clone = liste[etat.iM].cloneNode(true);
      clone.removeAttribute('hidden');
      scene.appendChild(clone);
      var barres = etat.lecteur.querySelector('.lucide-story-lecteur__barres');
      var html = '';
      for (var i = 0; i < liste.length; i++) {
        html += '<span class="lucide-story-lecteur__barre"><i style="width:' + (i < etat.iM ? '100%' : '0') + '"></i></span>';
      }
      barres.innerHTML = html;
      var fil = barres.children[etat.iM].firstElementChild;
      var video = clone.querySelector('video');
      if (video) {
        video.muted = !etat.sonActif;
        video.currentTime = 0;
        video.play().catch(function () {});
        video.addEventListener('timeupdate', function () {
          if (video.duration) fil.style.width = ((video.currentTime / video.duration) * 100) + '%';
        });
        video.addEventListener('ended', suivant);
      } else {
        var duree = (parseFloat(liste[etat.iM].getAttribute('data-duree')) || 5) * 1000;
        fil.style.transition = 'width ' + duree + 'ms linear';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { fil.style.width = '100%'; });
        });
        etat.timer = setTimeout(suivant, duree);
      }
    }

    function suivant() {
      if (!etat) return;
      var liste = lesMedias(etat.bulles[etat.iB]);
      if (etat.iM + 1 < liste.length) { etat.iM += 1; montrer(); } else { suivantBulle(); }
    }

    function suivantBulle() {
      if (!etat) return;
      for (var i = etat.iB + 1; i < etat.bulles.length; i++) {
        if (lesMedias(etat.bulles[i]).length) { etat.iB = i; etat.iM = 0; montrer(); return; }
      }
      fermer();
    }

    function precedent() {
      if (!etat) return;
      if (etat.iM > 0) { etat.iM -= 1; montrer(); return; }
      for (var i = etat.iB - 1; i >= 0; i--) {
        var liste = lesMedias(etat.bulles[i]);
        if (liste.length) { etat.iB = i; etat.iM = liste.length - 1; montrer(); return; }
      }
      montrer();
    }

    document.addEventListener('click', function (e) {
      var bulle = e.target.closest('[data-lucide-bulle]');
      if (bulle) {
        var conteneur = bulle.closest('.lucide-stories');
        var bulles = Array.prototype.slice.call(conteneur.querySelectorAll('[data-lucide-bulle]'));
        etat = {
          lecteur: conteneur.querySelector('[data-lucide-lecteur]'),
          bulles: bulles,
          iB: bulles.indexOf(bulle),
          iM: 0,
          sonActif: false,
          timer: null
        };
        pauserApercus(); /* pas deux lectures en même temps */
        try { etat.lecteur.showModal(); } catch (err) {}
        /* Page verrouillée derrière le lecteur (2026-08-22) — verrou natif d'Horizon */
        document.documentElement.setAttribute('scroll-lock', '');
        montrer();
        return;
      }
      if (e.target.closest('[data-lucide-fermer]')) { fermer(); return; }
      var son = e.target.closest('[data-lucide-son]');
      if (son) {
        etat.sonActif = !etat.sonActif;
        if (etat.sonActif) { son.setAttribute('data-son-actif', ''); } else { son.removeAttribute('data-son-actif'); }
        var video = etat.lecteur.querySelector('.lucide-story-lecteur__scene video');
        if (video) video.muted = !etat.sonActif;
        return;
      }
      if (e.target.closest('[data-lucide-avant]')) { precedent(); return; }
      if (e.target.closest('[data-lucide-apres]')) { suivant(); return; }
    });

    document.addEventListener('close', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-lucide-lecteur]')) {
        if (etat) { arreter(); etat = null; }
        e.target.querySelector('.lucide-story-lecteur__scene').innerHTML = '';
        reprendreApercus();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-cliniciens"] && !Shopify.designMode) return;
  try {
    /* Autonomie : ce bloc peut vivre sur une page SANS le bloc « Lucide — Liens ».
     Il embarque donc le même mécanisme d'ancre — et sort si l'autre a déjà agi
     (defaultPrevented), pour ne jamais faire le trajet deux fois. */
  if (!window.__lucideAncreCliniciens) {
    window.__lucideAncreCliniciens = true;
    document.addEventListener('click', function (e) {
      var lien = e.target.closest && e.target.closest('.lcli__lien[data-lucide-lien-ancre]');
      if (!lien || e.defaultPrevented) return;
      var id = (lien.getAttribute('href') || '').slice(1);
      var cible = id && document.getElementById(id);
      if (!cible) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('lucide:reveler', { detail: cible }));
      var pliage = cible.closest('details');
      if (pliage) pliage.open = true;
      var douceur =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      cible.scrollIntoView({ behavior: douceur, block: 'start' });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-echelle-cures"] && !Shopify.designMode) return;
  try {
    (function () {
    /* La cure cochée débloque SON cadeau et ceux des cures précédentes (ordre de la rangée).
       Les cadeaux des cures (<template data-lech-g>) sont recopiés en vignettes dans le cadre
       de la carte Abonnement et, comme « non inclus », dans le volet de l'achat unique.
       Les textes à repères ([eco] [rythme] [mois] [n] [total]…) sont remplis ici. */
    if (customElements.get('lucide-echelle')) return;
    function nombre(s) {
      var n = parseFloat(String(s || '').replace(/[^0-9,.\-]/g, '').replace(',', '.'));
      return isNaN(n) ? null : n;
    }
    function euros(v, modele) {
      var t = Math.round(v * 100) % 100 === 0 ? String(Math.round(v)) : v.toFixed(2).replace('.', ',');
      return /€/.test(modele || '') ? t + ' €' : t;
    }
    function remplir(el, modele, vals) {
      el.textContent = '';
      if (!modele) return;
      var gras = el.hasAttribute('data-lech-gras');
      modele.split(/(\[[a-z_]+\])/).forEach(function (morceau) {
        var m = morceau.match(/^\[([a-z_]+)\]$/);
        if (m && Object.prototype.hasOwnProperty.call(vals, m[1])) {
          var v = String(vals[m[1]]);
          if (gras) {
            var b = document.createElement('b');
            b.textContent = v;
            el.appendChild(b);
          } else {
            el.appendChild(document.createTextNode(v));
          }
        } else if (morceau) {
          el.appendChild(document.createTextNode(morceau));
        }
      });
    }
    function chaque(liste, f) {
      Array.prototype.forEach.call(liste, f);
    }
    /* 03/11 : un cadeau porte-t-il le nom de l'« Avantage en achat unique » de la cure ? */
    function memeNom(a, b) {
      return !!b && String(a || '').trim().toLowerCase() === String(b).trim().toLowerCase();
    }
    /* économie d'UNE cure : « Économie » saisie, sinon prix barré − prix */
    function ecoDe(cure) {
      var e = cure.getAttribute('data-eco');
      if (e) return e;
      var b = nombre(cure.getAttribute('data-barre'));
      var p = nombre(cure.getAttribute('data-prix'));
      return b !== null && p !== null && b > p ? euros(b - p, cure.getAttribute('data-barre')) : '';
    }
    customElements.define(
      'lucide-echelle',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this._change = function () {
            self.maj(true);
          };
          this._clic = function (e) {
            self.clic(e);
          };
          this._touche = function (e) {
            if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-lech-retour]')) {
              e.preventDefault();
              self.versAbo();
            }
          };
          this.addEventListener('change', this._change);
          this.addEventListener('click', this._clic);
          this.addEventListener('keydown', this._touche);
          this.construire();
          /* rangée en Liste : les cartes de fréquence prennent ses couleurs, son arrondi et ses tailles */
          var palL = this.querySelector('.lech-pal--liste');
          this.classList.toggle('lech--liste', !!palL || !!this.querySelector('[data-lech-ligne]'));
          if (palL) {
            ['--lech-t-fond', '--lech-t-fond-a', '--lech-t-r', '--lech-bd-f', '--lech-bd-c', '--lech-bd-t', '--lech-pct', '--lech-pct-m',
              '--lech-mois', '--lech-mois-m', '--lech-mois-g', '--lech-jour', '--lech-jour-m', '--lech-tp', '--lech-tp-m', '--lech-gap', '--lech-gap-m'].forEach(function (v) {
              var x = palL.style.getPropertyValue(v);
              if (x) self.style.setProperty(v, x);
            });
          }
          this.classList.add('lech--pret');
          this.maj(false);
        }
        disconnectedCallback() {
          this.removeEventListener('change', this._change);
          this.removeEventListener('click', this._clic);
          this.removeEventListener('keydown', this._touche);
        }
        cures() {
          return Array.prototype.slice.call(this.querySelectorAll('[data-lech-palier]'));
        }
        construire() {
          var boites = this.querySelectorAll('[data-lech-cadeaux]');
          var pertes = this.querySelectorAll('[data-lech-pertes]');
          chaque(boites, function (b) {
            b.textContent = '';
          });
          chaque(pertes, function (b) {
            b.textContent = '';
          });
          var total = 0;
          /* 03/11 : une cure peut porter jusqu'à 3 cadeaux (pack Mode Lucide) */
          this.cures().forEach(function (cure, i) {
            chaque(cure.querySelectorAll('template[data-lech-g]'), function (modele) {
            if (!modele.content.firstElementChild) return;
            total++;
            chaque(boites, function (b) {
              var v = modele.content.firstElementChild.cloneNode(true);
              v.setAttribute('data-seuil', i);
              b.appendChild(v);
            });
            chaque(pertes, function (b) {
              var v = modele.content.firstElementChild.cloneNode(true);
              v.setAttribute('data-seuil', i);
              v.classList.add('lech-v--perdu');
              var cd = v.querySelector('.lech-v__cd');
              if (cd) cd.remove();
              var etat = v.querySelector('.lech-v__e');
              if (etat) etat.textContent = b.getAttribute('data-non-inclus') || '';
              b.appendChild(v);
            });
            });
          });
          this._total = total;
        }
        maj(anime) {
          var cures = this.cures();
          if (!cures.length) return;
          var choix = -1;
          cures.forEach(function (cure, i) {
            var radio = cure.querySelector('.lech-p__radio');
            if (radio && radio.checked && choix < 0) choix = i;
          });
          if (choix < 0) {
            choix = 0;
            var premier = cures[0].querySelector('.lech-p__radio');
            if (premier) premier.checked = true;
          }
          var modes = this.querySelectorAll('.lech-c__radio');
          var unique = false;
          var coche = null;
          chaque(modes, function (m) {
            if (m.checked && !coche) coche = m;
          });
          if (modes.length && !coche) {
            coche = this.querySelector('.lech-c__radio[value="abo"]') || modes[0];
            coche.checked = true;
          }
          if (coche) unique = coche.value === 'unique';
          var retourAbo = this._unique === true && !unique;
          this._unique = unique;
          this.classList.toggle('lech--unique', unique);
          chaque(this.querySelectorAll('[data-lech-carte]'), function (k) {
            var rond = k.querySelector('.lech-c__radio');
            k.classList.toggle('lech-c--on', !!(rond && rond.checked));
          });

          var n = 0;
          var moi = this;
          cures.forEach(function (cure, i) {
            cure.classList.toggle('lech-p--actif', i === choix);
            if (i <= choix) n += cure.querySelectorAll('template[data-lech-g]').length;
            var jour = cure.querySelector('[data-lech-jour]');
            if (jour) {
              var j = unique ? cure.getAttribute('data-jour-unique') || cure.getAttribute('data-jour') : cure.getAttribute('data-jour');
              jour.textContent = j || '';
              jour.hidden = !j;
            }
            /* tuile « prix de la cure » : barré + prix en abonnement, prix plein en achat unique
               (cibles en data-x-* : jamais les data-attributs de la tuile elle-même) */
            var tp = cure.querySelector('[data-lech-tprix]');
            if (tp) {
              var tb = tp.querySelector('[data-x-barre]');
              var tx = tp.querySelector('[data-x-prix]');
              var pv = unique ? cure.getAttribute('data-unique') || cure.getAttribute('data-prix') : cure.getAttribute('data-prix');
              var bv = unique ? '' : cure.getAttribute('data-barre');
              if (nombre(bv) !== null && nombre(pv) !== null && nombre(bv) <= nombre(pv)) bv = '';
              if (tx) tx.textContent = pv || '';
              if (tb) {
                tb.textContent = bv || '';
                tb.hidden = !bv;
              }
            }
            var bd = cure.querySelector('[data-lech-badge]');
            if (bd) {
              var ec = ecoDe(cure);
              remplir(bd, ec ? bd.getAttribute('data-lech-badge') : '', { eco: ec });
              bd.hidden = !ec;
            }
            /* disposition Liste (15/10) : badge de remise [pct], cadeaux de la cure choisie */
            var pal = cure.closest('.lech-pal--liste');
            var pc = cure.querySelector('[data-lech-pct]');
            if (pc) {
              var pb = nombre(cure.getAttribute('data-barre'));
              var pp = nombre(cure.getAttribute('data-prix'));
              var pct = pal && !unique && pb && pp !== null && pb > pp ? Math.round(((pb - pp) / pb) * 100) : 0;
              var mp = pal ? pal.getAttribute('data-pct') : '';
              remplir(pc, pct && mp ? mp : '', { pct: pct });
              pc.hidden = !(pct && mp);
            }
            var lst = cure.querySelector('[data-lech-lst]');
            if (lst) {
              lst.textContent = '';
              if (pal && i === choix) moi.liste(lst, cures.slice(0, i + 1), pal, unique);
            }
          });
          var sel = cures[choix];
          /* carte Abonnement en Liste : badge de remise [pct] de la cure choisie */
          var palP = this.querySelector('.lech-pal--liste');
          chaque(this.querySelectorAll('[data-lech-pct-abo]'), function (el) {
            var src = el.closest('[data-pct]') || palP;
            var mp = src ? src.getAttribute('data-pct') : '';
            var b = nombre(sel.getAttribute('data-barre'));
            var p = nombre(sel.getAttribute('data-prix'));
            var pc = mp && b && p !== null && b > p ? Math.round(((b - p) / b) * 100) : 0;
            remplir(el, pc ? mp : '', { pct: pc });
            el.hidden = !pc;
          });
          /* cartes en Ligne : la carte cochée s'ouvre sur les cadeaux de la cure choisie
             (grisés, « non inclus », sur la carte Achat unique) */
          var enLigne = this.classList.contains('lech--liste');
          chaque(this.querySelectorAll('[data-lech-lst-carte]'), function (lc) {
            lc.textContent = '';
            var carte = lc.closest('[data-lech-carte]');
            if (!enLigne || !carte || !carte.classList.contains('lech-c--on')) return;
            moi.liste(lc, cures.slice(0, choix + 1), carte, carte.getAttribute('data-lech-carte') === 'unique');
          });
          function lire(cle) {
            return sel.getAttribute('data-' + cle) || '';
          }
          var eco = lire('eco');
          if (!eco) {
            var b = nombre(lire('barre'));
            var p = nombre(lire('prix'));
            if (b !== null && p !== null && b > p) eco = euros(b - p, lire('barre'));
          }
          var vals = {
            eco: eco,
            rythme: lire('rythme'),
            mois: lire('mois'),
            prix: lire('prix'),
            barre: lire('barre'),
            unique: lire('unique') || lire('prix'),
            jour: lire('jour'),
            jour_unique: lire('jour-unique') || lire('jour'),
            avantage: lire('avantage-unique'),
            n: n,
            total: this._total || 0
          };
          chaque(this.querySelectorAll('[data-lech-v]'), function (el) {
            var v = vals[el.getAttribute('data-lech-v')];
            el.textContent = v || '';
            el.hidden = !v;
          });
          chaque(this.querySelectorAll('[data-lech-modele]'), function (el) {
            /* 03/11 : cure avec un avantage en achat unique = la petite ligne prévue pour (carte Achat unique) */
            var ma = vals.avantage && el.getAttribute('data-lech-modele-avantage');
            remplir(el, ma || el.getAttribute('data-lech-modele'), vals);
          });
          var tous = vals.total > 0 && n >= vals.total;
          chaque(this.querySelectorAll('[data-lech-etiquette]'), function (el) {
            var m = tous ? el.getAttribute('data-tous') : n > 1 ? el.getAttribute('data-plusieurs') : el.getAttribute('data-un');
            remplir(el, m, vals);
          });

          /* vignettes : débloquées jusqu'à la cure choisie ; le cadenas s'ouvre sur les
             nouvelles (et sur toutes au retour de l'achat unique) */
          var anim = anime && !unique;
          chaque(this.querySelectorAll('.lech-v[data-seuil]'), function (v) {
            /* 03/11 : le cadeau devenu avantage en achat unique quitte le volet « non inclus » */
            if (v.classList.contains('lech-v--perdu')) {
              var vn = v.querySelector('.lech-v__n');
              v.style.display = vn && memeNom(vn.textContent, vals.avantage) ? 'none' : '';
            }
            var ok = +v.getAttribute('data-seuil') <= choix;
            var avant = v.classList.contains('lech-v--ok');
            v.classList.toggle('lech-v--ok', ok);
            v.classList.toggle('lech-v--ko', !ok);
            if (anim && ok && (!avant || retourAbo) && !v.classList.contains('lech-v--perdu')) {
              v.classList.remove('lech-v--ouvre');
              void v.offsetWidth;
              v.classList.add('lech-v--ouvre');
              clearTimeout(v._lechT);
              v._lechT = setTimeout(function () {
                v.classList.remove('lech-v--ouvre');
              }, 1100);
            }
          });

          var totalG = lire('total-g');
          var totalD = lire('total-d');
          chaque(this.querySelectorAll('[data-lech-total]'), function (tot) {
            var g = tot.querySelector('[data-lech-total-g]');
            var d = tot.querySelector('[data-lech-total-d]');
            if (g) g.textContent = totalG;
            if (d) d.textContent = totalD;
            tot.classList.toggle('lech-tot--plein', !!(totalG || totalD));
          });

          var prix = unique ? vals.unique : vals.prix;
          var barre = unique ? '' : vals.barre;
          chaque(this.querySelectorAll('[data-lech-cta]'), function (bouton) {
            var t = bouton.querySelector('[data-lech-cta-txt]');
            var p = bouton.querySelector('[data-lech-cta-prix]');
            var br = bouton.querySelector('[data-lech-cta-barre]');
            var s = bouton.querySelector('[data-lech-cta-sep]');
            if (t) t.textContent = (unique && bouton.getAttribute('data-texte-unique')) || bouton.getAttribute('data-texte') || '';
            if (p) {
              p.textContent = prix || '';
              p.hidden = !prix;
            }
            if (br) {
              br.textContent = barre || '';
              br.hidden = !barre;
            }
            if (s) s.hidden = !prix;
            bouton.setAttribute('data-cure', vals.mois);
            bouton.setAttribute('data-mode', unique ? 'unique' : 'abonnement');
          });
          /* bouton « Achat unique, sans abonnement » : prix en achat unique de la cure choisie */
          chaque(this.querySelectorAll('[data-lech-cta2]'), function (b2) {
            var p2 = b2.querySelector('[data-lech-cta2-prix]');
            var s2 = b2.querySelector('[data-lech-cta2-sep]');
            if (p2) {
              p2.textContent = vals.unique || '';
              p2.hidden = !vals.unique;
            }
            if (s2) s2.hidden = !vals.unique;
            b2.setAttribute('data-cure', vals.mois);
          });
          chaque(this.querySelectorAll('[data-lech-note]'), function (note) {
            remplir(note, note.getAttribute(unique ? 'data-unique' : 'data-abo'), vals);
          });
        }
        /* les cadeaux débloqués jusqu'à la cure choisie : image, nom, (valeur), et leur total */
        liste(lst, cures, pal, unique) {
          var total = 0;
          var monnaie = '';
          var items = [];
          var inclus = null;
          /* 03/11 : en achat unique, l'avantage de la cure choisie (ex. Livraison offerte) n'est pas « non inclus » */
          var sauf = unique && cures.length ? cures[cures.length - 1].getAttribute('data-avantage-unique') : '';
          cures.forEach(function (cure) {
            chaque(cure.querySelectorAll('template[data-lech-g]'), function (m) {
            var v = m.content.firstElementChild;
            if (!v) return;
            var nom = v.querySelector('.lech-v__n');
            if (nom && memeNom(nom.textContent, sauf)) {
              /* 03/11 (Omar) : l'avantage garde son icône, en « Inclus » au-dessus des non inclus */
              var vi = v.querySelector('.lech-v__v');
              if (!inclus) inclus = { n: nom.textContent.trim(), v: vi ? vi.textContent.trim() : '', ic: v.querySelector('.lech-v__ic') };
              return;
            }
            var val = v.querySelector('.lech-v__v');
            var vt = val ? val.textContent.trim() : '';
            var x = nombre(vt);
            if (x !== null && /€/.test(vt)) {
              total += x;
              monnaie = vt;
            }
            items.push({ n: nom ? nom.textContent.trim() : '', v: vt, ic: v.querySelector('.lech-v__ic') });
            });
          });
          var mvSrc = pal.hasAttribute('data-lst-valeur') ? pal : this.querySelector('[data-lst-valeur]');
          var mv = (mvSrc && mvSrc.getAttribute('data-lst-valeur')) || '[valeur]';
          function ligneDe(it) {
            var ligne = document.createElement('span');
            ligne.className = 'lech-lst__i';
            var im = document.createElement('span');
            im.className = 'lech-lst__img';
            if (it.ic) {
              chaque(it.ic.childNodes, function (k) {
                im.appendChild(k.cloneNode(true));
              });
            }
            var tx = document.createElement('span');
            var b = document.createElement('b');
            b.className = 'lech-lst__n';
            b.textContent = it.n;
            tx.appendChild(b);
            if (it.v) {
              var euro = /€/.test(it.v);
              var tmp = document.createElement('span');
              remplir(tmp, euro ? mv : '[valeur]', { valeur: euro ? it.v : it.v.charAt(0).toLowerCase() + it.v.slice(1) });
              var s = document.createElement('span');
              s.className = 'lech-lst__v';
              s.textContent = ' (' + tmp.textContent + ')';
              tx.appendChild(s);
            }
            ligne.appendChild(im);
            ligne.appendChild(tx);
            return ligne;
          }
          lst.classList.toggle('lech-lst--perdu', !!unique);
          if (inclus) {
            var pi = document.createElement('p');
            pi.className = 'lech-lst__t';
            pi.textContent = pal.getAttribute('data-lst-titre-inclus') || 'Inclus en achat unique :';
            lst.appendChild(pi);
            var li = ligneDe(inclus);
            li.classList.add('lech-lst__i--inclus');
            lst.appendChild(li);
          }
          if (!items.length) return;
          var titre = (unique ? pal.getAttribute('data-lst-titre-unique') : pal.getAttribute('data-lst-titre')) || '';
          if (titre) {
            var p = document.createElement('p');
            p.className = 'lech-lst__t';
            remplir(p, total ? titre : titre.replace(/\s*\([^)]*\[valeur\][^)]*\)/, ''), { valeur: euros(total, monnaie) });
            lst.appendChild(p);
          }
          items.forEach(function (it) {
            lst.appendChild(ligneDe(it));
          });
        }
        clic(e) {
          var t = e.target;
          if (!t.closest) return;
          /* bouton : la cure choisie part au panier (26/10) — 1, 2 ou 3 flacons selon « N mois » */
          var cta = t.closest('button[data-lech-cta], button[data-lech-cta2]');
          if (cta) {
            e.preventDefault();
            this.ajouter(cta, cta.hasAttribute('data-lech-cta2'));
            return;
          }
          if (t.closest('[data-lech-retour]')) {
            e.preventDefault();
            this.versAbo();
            return;
          }
          var v = t.closest('.lech-v--ko[data-seuil]');
          if (v && !v.classList.contains('lech-v--perdu')) {
            e.preventDefault();
            var cure = this.cures()[+v.getAttribute('data-seuil')];
            var radio = cure && cure.querySelector('.lech-p__radio');
            if (radio) {
              radio.checked = true;
              this.maj(true);
            }
          }
        }
        ajouter(b, forceUnique) {
          var variante = this.getAttribute('data-variante');
          if (!variante) return;
          var cures = this.cures();
          var cure = cures.filter(function (cu) {
            var rd = cu.querySelector(".lech-p__radio");
            return rd && rd.checked;
          })[0] || cures[0];
          var qte = (cure && parseInt(cure.getAttribute('data-mois'), 10)) || 1;
          var unique = forceUnique || this._unique === true;
          var plans = (this.getAttribute('data-plans') || '').split(',').filter(Boolean);
          var plan = unique ? '' : plans[qte - 1] || plans[0] || '';
          var item = { id: Number(variante), quantity: qte };
          if (plan) item.selling_plan = Number(plan);
          /* 03/11 : en abonnement de 2 ou 3 mois, les vrais produits cadeau partent avec la cure (0 €, quantité 1,
             propriété cachée _cadeau) : 2 mois = le guide, 3 mois = le guide + la vitamine C (ids : Thème → LUCIDE) */
          var items = [item];
          var duree = plan ? (plans[qte - 1] ? qte : 1) : 0;
          /* 03/11 : pack Mode Lucide (réglage « Pack : tous les cadeaux dès le 1er mois ») — en abonnement, le guide et la vitamine C */
          if (plan && this.hasAttribute('data-cadeaux-pack')) duree = 3;
          var self = this;
          [[2, 'data-cadeau-2'], [3, 'data-cadeau-3']].forEach(function (c) {
            var id = String(self.getAttribute(c[1]) || '').replace(/\D/g, '');
            if (id && duree >= c[0]) items.push({ id: Number(id), quantity: 1, properties: { _cadeau: '1' } });
          });
          /* abonnement demandé mais pas encore créé dans Shopify : la cure part en achat unique, on le dit */
          var note = this.querySelector('[data-lech-note]');
          if (!unique && !plan && this.getAttribute('data-sans-abo')) {
            if (!note) {
              note = document.createElement('p');
              note.className = 'lech-cta-note';
              note.setAttribute('data-lech-note', '');
              b.insertAdjacentElement('afterend', note);
            }
            note.textContent = this.getAttribute('data-sans-abo');
          }
          var tiroir = document.querySelector('lucide-tiroir');
          b.disabled = true;
          var fin = function () {
            b.disabled = false;
          };
          if (tiroir && tiroir.ajouterEtOuvrir) {
            tiroir.ajouterEtOuvrir(items).then(fin, fin);
          } else {
            var envoi = function (liste) {
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: liste }) });
            };
            /* cadeau refusé par Shopify (épuisé…) : la cure repart seule */
            envoi(items)
              .then(function (r) {
                return r.ok || items.length === 1 ? r : envoi([item]);
              })
              .then(function () {
                window.location.href = '/cart';
              }, fin);
          }
        }
        versAbo() {
          var radio = this.querySelector('.lech-c__radio[value="abo"]');
          if (radio) {
            radio.checked = true;
            this.maj(true);
          }
        }
      }
    );
    /* Éditeur : sélectionner une cure ou une carte dans la barre latérale la coche. */
    document.addEventListener('shopify:block:select', function (e) {
      var cible = e.target && e.target.closest && e.target.closest('[data-lech-palier], [data-lech-carte]');
      if (!cible) return;
      var radio = cible.querySelector('.lech-p__radio, .lech-c__radio');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lucide-faq-groupe')) {
    customElements.define(
      'lucide-faq-groupe',
      class LucideFaqGroupe extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('exclusif')) return;

          const lignes = this.querySelectorAll('details');
          if (lignes.length === 0) return;

          if (!this.groupName) {
            this.groupName = 'faq-' + Math.random().toString(36).slice(2, 10);
          }

          let ouverte = null;
          lignes.forEach((ligne) => {
            if (!ligne.open) return;
            if (ouverte) {
              ligne.open = false;
            } else {
              ouverte = ligne;
            }
          });

          lignes.forEach((ligne) => {
            ligne.setAttribute('name', this.groupName);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-jauges"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideJauInit) return;
    window.lucideJauInit = true;

    function surveiller() {
      var blocs = document.querySelectorAll('.ljau--anime:not(.ljau--vue)');
      if (!blocs.length) return;
      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(blocs, function (b) { b.classList.add('ljau--vue'); });
        return;
      }
      var oeil = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('ljau--vue');
          oeil.unobserve(e.target);
        });
      }, { threshold: 0.25 });
      Array.prototype.forEach.call(blocs, function (b) { oeil.observe(b); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', surveiller);
    } else {
      surveiller();
    }
    /* dans l'éditeur, une section rechargée doit réarmer ses jauges */
    document.addEventListener('shopify:section:load', surveiller);
    document.addEventListener('shopify:block:select', surveiller);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-liens"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.lucideLiensInit) return;
    window.lucideLiensInit = true;

    /* Un lien « image » fait défiler la galerie produit jusqu'à l'image choisie.
       Horizon expose une vignette par image (bouton `ref="thumbnails[]"`) : la
       cliquer sélectionne l'image. Sans vignettes (galerie en pile), on fait
       défiler directement jusqu'à la diapositive. */
    document.addEventListener('click', function (e) {
      var lien = e.target.closest('[data-lucide-lien-media]');
      if (!lien) return;
      var rang = parseInt(lien.getAttribute('data-lucide-lien-media'), 10) - 1;
      if (isNaN(rang) || rang < 0) return;

      var galerie = document.querySelector('media-gallery');
      if (!galerie) return;

      var vignettes = galerie.querySelectorAll('button[ref="thumbnails[]"]');
      if (vignettes.length > rang) {
        vignettes[rang].click();
      } else {
        var diapos = galerie.querySelectorAll('.product-media[data-media-id]');
        if (diapos.length > rang) {
          diapos[rang].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      galerie.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    /* Un lien « ancre » glisse jusqu'à la cible (question de FAQ ou section).
       Si la cible est une question fermée (details), on l'OUVRE d'abord —
       l'ouverture par ancre seule n'est pas fiable d'un navigateur à l'autre. */
    document.addEventListener('click', function (e) {
      var lien = e.target.closest('[data-lucide-lien-ancre]');
      if (!lien) return;
      var id = (lien.getAttribute('href') || '').slice(1);
      var cible = id && document.getElementById(id);
      if (!cible) return;
      e.preventDefault();
      /* Si la cible vit dans un onglet de FAQ caché, le révéler d'abord */
      document.dispatchEvent(new CustomEvent('lucide:reveler', { detail: cible }));
      var pliage = cible.closest('details');
      if (pliage) pliage.open = true;
      var douceur = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      cible.scrollIntoView({ behavior: douceur, block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-pack-gammes"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Compteurs − / + par gamme ; total des flacons → cadeaux débloqués (seuil de chaque
       cadeau), prix total de l'en-tête et du bouton, étiquette des cadeaux. */
    if (customElements.get('lucide-pack')) return;
    function nombre(texte) {
      var v = parseFloat(String(texte || '').replace(/\s/g, '').replace(',', '.').replace(/[^0-9.]/g, ''));
      return isNaN(v) ? 0 : v;
    }
    customElements.define(
      'lucide-pack',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this._clic = function (e) {
            var bouton = e.target.closest('[data-lmlp-moins], [data-lmlp-plus]');
            if (!bouton || !self.contains(bouton)) return;
            var carte = bouton.closest('[data-lmlp-carte]');
            if (!carte) return;
            var max = parseInt(self.getAttribute('data-max'), 10) || 6;
            var q = parseInt(carte.getAttribute('data-q'), 10) || 0;
            q = bouton.hasAttribute('data-lmlp-plus') ? Math.min(max, q + 1) : Math.max(0, q - 1);
            carte.setAttribute('data-q', q);
            self.maj(true);
          };
          this.addEventListener('click', this._clic);
          this.maj(false);
        }
        disconnectedCallback() {
          this.removeEventListener('click', this._clic);
        }
        prix(v) {
          var devise = this.getAttribute('data-devise') || '';
          return v.toFixed(2).replace('.', ',') + devise;
        }
        maj(anime) {
          var self = this;
          var max = parseInt(this.getAttribute('data-max'), 10) || 6;
          var cartes = Array.prototype.slice.call(this.querySelectorAll('[data-lmlp-carte]'));
          var total = 0;
          var somme = 0;
          var sommeBarre = 0;
          cartes.forEach(function (carte) {
            if (!carte.hasAttribute('data-q')) carte.setAttribute('data-q', carte.getAttribute('data-depart') || '0');
            var q = parseInt(carte.getAttribute('data-q'), 10) || 0;
            total += q;
            somme += q * nombre(carte.getAttribute('data-prix'));
            sommeBarre += q * nombre(carte.getAttribute('data-barre'));
            var aff = carte.querySelector('[data-lmlp-q]');
            if (aff) aff.textContent = q;
            carte.classList.toggle('lmlp-c--vide', q === 0);
            var moins = carte.querySelector('[data-lmlp-moins]');
            var plus = carte.querySelector('[data-lmlp-plus]');
            if (moins) moins.disabled = q === 0;
            if (plus) plus.disabled = q >= max;
          });
          if (total === 0 && cartes.length) {
            somme = nombre(cartes[0].getAttribute('data-prix'));
            sommeBarre = nombre(cartes[0].getAttribute('data-barre'));
          }
          Array.prototype.forEach.call(this.querySelectorAll('[data-lmlp-prix]'), function (el) {
            el.textContent = self.prix(somme);
          });
          Array.prototype.forEach.call(this.querySelectorAll('[data-lmlp-barre]'), function (el) {
            el.textContent = sommeBarre > somme ? self.prix(sommeBarre) : '';
            el.hidden = !(sommeBarre > somme);
          });
          Array.prototype.forEach.call(this.querySelectorAll('[data-lmlp-lab]'), function (lab) {
            lab.textContent = total ? lab.getAttribute('data-ok') : lab.getAttribute('data-vide');
            lab.classList.toggle('lmlp-lab--ok', total > 0);
            lab.classList.toggle('lmlp-lab--non', total === 0);
          });
          Array.prototype.forEach.call(this.querySelectorAll('[data-lmlp-cadeau]'), function (g) {
            var seuil = parseInt(g.getAttribute('data-seuil'), 10) || 1;
            var ouvert = total >= seuil;
            var avant = g.classList.contains('lmlp-g--ouvert');
            g.classList.toggle('lmlp-g--ouvert', ouvert);
            g.classList.toggle('lmlp-g--ferme', !ouvert);
            if (anime && ouvert && !avant) {
              var ico = g.querySelector('.lmlp-g__ico');
              if (ico) {
                ico.classList.remove('lmlp-flash');
                void ico.offsetWidth;
                ico.classList.add('lmlp-flash');
              }
            }
          });
          Array.prototype.forEach.call(this.querySelectorAll('[data-lmlp-cta]'), function (bouton) {
            var txt = bouton.querySelector('[data-lmlp-cta-txt]');
            if (txt) txt.textContent = total ? bouton.getAttribute('data-texte') : bouton.getAttribute('data-texte-vide');
            Array.prototype.forEach.call(bouton.querySelectorAll('[data-lmlp-cta-sep], [data-lmlp-cta-prix]'), function (el) {
              el.hidden = !total;
            });
            var p = bouton.querySelector('[data-lmlp-cta-prix]');
            if (p) p.textContent = self.prix(somme);
            var b = bouton.querySelector('[data-lmlp-cta-barre]');
            if (b) {
              b.textContent = sommeBarre > somme ? self.prix(sommeBarre) : '';
              b.hidden = !total || !(sommeBarre > somme);
            }
            if (bouton.tagName === 'BUTTON') bouton.disabled = !total;
            else bouton.setAttribute('aria-disabled', total ? 'false' : 'true');
            bouton.setAttribute('data-flacons', total);
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-pictos"] && !Shopify.designMode) return;
  try {
    /* « Ordinateur : sous les photos » : le bloc posé dans « Détails du produit » part sous la
     galerie à partir de 750 px et revient à sa place en dessous (patron lucide-avis-verifie). */
  (function () {
    if (window.lucidePictos) return;
    window.lucidePictos = true;
    var origines = new Map();
    var mq = window.matchMedia('(max-width: 749px)');
    function remettre(noeud) {
      var o = origines.get(noeud);
      if (!o || noeud.parentElement === o.parent) return;
      if (o.suivant && o.suivant.parentElement === o.parent) o.parent.insertBefore(noeud, o.suivant);
      else o.parent.appendChild(noeud);
    }
    function deplacer(noeud, cible) {
      if (!cible || noeud.parentElement === cible) return;
      if (!origines.has(noeud)) origines.set(noeud, { parent: noeud.parentElement, suivant: noeud.nextSibling });
      cible.appendChild(noeud);
    }
    function placer() {
      var blocs = document.querySelectorAll('[data-lpic-ordi-photos]');
      for (var i = 0; i < blocs.length; i++) {
        var noeud = blocs[i];
        var grille = noeud.closest('.product-information__grid');
        if (!grille) continue;
        if (mq.matches) remettre(noeud);
        else deplacer(noeud, grille.querySelector('.lucide-sous-galerie') || grille.querySelector('.product-information__media'));
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placer);
    else placer();
    mq.addEventListener('change', placer);
    document.addEventListener('shopify:section:load', function () { origines = new Map(); placer(); });
    document.addEventListener('shopify:block:select', placer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lucide-stock-livraison"] && !Shopify.designMode) return;
  try {
    /* Recalcule la date de livraison dans le navigateur (le Liquid peut être servi depuis un cache). */
  (function () {
    if (window.lucideStockLivraison) return;
    window.lucideStockLivraison = true;
    function calculer(el) {
      var delai = parseInt(el.getAttribute('data-delai') || '0', 10);
      var exclus = el.getAttribute('data-exclus') || 'aucun';
      var heure = parseInt(el.getAttribute('data-heure') || '0', 10);
      var maj = el.getAttribute('data-maj') === '1';
      var d = new Date();
      if (heure > 0 && d.getHours() >= heure) d.setDate(d.getDate() + 1);
      d.setDate(d.getDate() + delai);
      for (var i = 0; i < 3; i++) {
        var w = d.getDay();
        if ((exclus === 'dimanche' || exclus === 'weekend') && w === 0) d.setDate(d.getDate() + 1);
        else if (exclus === 'weekend' && w === 6) d.setDate(d.getDate() + 2);
      }
      var txt = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      if (maj) txt = txt.charAt(0).toUpperCase() + txt.slice(1);
      var cible = el.querySelector('[data-lsl-cible]');
      if (cible) cible.textContent = txt;
    }
    function tout() {
      var liste = document.querySelectorAll('[data-lsl-date]');
      for (var i = 0; i < liste.length; i++) calculer(liste[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
    else tout();
    document.addEventListener('shopify:section:load', tout);
    document.addEventListener('shopify:block:select', tout);
  })();
  } catch(e) { console.error(e); }
})();

})();
